import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('tr');

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'tr' ? 'en' : 'tr');
  };

  const t = (key) => {
    const translations = {
      tr: {
        dashboard_title: 'BridgePrep',
        dashboard_subtitle: 'BridgePrep students to global and local exams',
        general_mentor: 'Genel STEM Danışmanı',
        general_mentor_desc: 'Tüm STEM konularında yardım',
        physics_mentor: 'Fizik Danışmanı',
        physics_mentor_desc: 'Mekanik, kuvvetler, enerji ve daha fazlası',
        math_mentor: 'Matematik Danışmanı',
        math_mentor_desc: 'Calculus, fonksiyonlar ve türev-integral',
        chemistry_mentor: 'Kimya Danışmanı',
        chemistry_mentor_desc: 'Atomlar, moleküller, reaksiyonlar',
        biology_mentor: 'Biyoloji Danışmanı',
        biology_mentor_desc: 'Hücreler, genetik, ekoloji',
        evaluator: 'Yanıt Değerlendirici',
        evaluator_desc: 'Yazılı yanıtlarınızı değerlendirin',
        question_generator: 'Soru Oluşturucu',
        question_generator_desc: 'AP ve TYT/AYT soruları oluşturun',
        study_planner: 'Çalışma Planlayıcı',
        study_planner_desc: 'Kişiselleştirilmiş çalışma planı',
        start_chat: 'Sohbete Başla',
        type_message: 'Mesajınızı yazın...',
        send: 'Gönder',
        new_chat: 'Yeni Sohbet',
        back: 'Geri',
        discipline: 'Disiplin',
        exam_context: 'Sınav Bağlamı',
        select_discipline: 'Disiplin seçin',
        physics: 'Fizik',
        mathematics: 'Matematik',
        chemistry: 'Kimya',
        biology: 'Biyoloji',
        evaluate: 'Değerlendir',
        student_response: 'Öğrenci Yanıtı',
        question_context: 'Soru Bağlamı (İsteğe bağlı)',
        enter_response: 'Yanıtınızı buraya yazın...',
        enter_context: 'Soru bağlamını buraya yazın...',
        evaluation_result: 'Değerlendirme Sonucu',
        generate_questions: 'Soru Oluştur',
        topic: 'Konu',
        enter_topic: 'Konuyu girin (örn: Newton\'un 2. Yasası)',
        difficulty: 'Zorluk',
        easy: 'Kolay',
        medium: 'Orta',
        hard: 'Zor',
        number_of_questions: 'Soru Sayısı',
        format: 'Format',
        generate: 'Oluştur',
        generated_questions: 'Oluşturulan Sorular',
        create_plan: 'Plan Oluştur',
        grade_level: 'Sınıf',
        target_exams: 'Hedef Sınavlar',
        weekly_hours: 'Haftalık Saat',
        hours: 'saat',
        weak_topics: 'Zayıf Konular (İsteğe bağlı)',
        study_plan_result: 'Çalışma Planı',
        loading: 'Yükleniyor...',
        error: 'Bir hata oluştu',
        // Question Bank
        question_bank: 'Soru Bankası',
        question_bank_desc: 'Binlerce soru',
        filters: 'Filtreler',
        all: 'Tümü',
        exam_type: 'Sınav Tipi',
        no_questions_found: 'Soru bulunamadı',
        question: 'Soru',
        options: 'Şıklar',
        correct_answer: 'Doğru Cevap',
        solution: 'Çözüm',
        // Teacher Portal
        teacher_portal: 'Öğretmen Portalı',
        teacher_portal_desc: 'Soru gönder',
        submit_question: 'Soru Gönder',
        question_text: 'Soru Metni',
        write_question: 'Sorunuzu buraya yazın...',
        submit: 'Gönder',
        my_submissions: 'Gönderilerim',
        no_submissions: 'Henüz gönderim yok',
        question_submitted: 'Sorunuz başarıyla gönderildi!',
        no_access: 'Bu sayfaya erişim izniniz yok.',
        status: 'Durum',
        // Booklet Designer
        booklet_designer: 'Kitapçık Tasarımcı',
        booklet_designer_desc: 'Kişisel kitapçık',
        create_new_booklet: 'Yeni Kitapçık Oluştur',
        week_number: 'Hafta Numarası',
        focus_subjects: 'Odak Konular',
        focus_topics: 'Odak Konular (virgülle ayırın)',
        my_booklets: 'Kitapçıklarım',
        no_booklets: 'Henüz kitapçık yok',
        week: 'Hafta',
        questions: 'soru',
        minutes: 'dk',
        // Booklet View
        learning_objectives: 'Öğrenme Hedefleri',
        sections: 'Bölümler',
        no_questions_in_booklet: 'Bu kitapçıkta henüz soru yok',
        make_sure_questions: 'Soru bankasında soru olduğundan emin olun veya yeni bir kitapçık oluşturun',
        reflection_questions: 'Düşünme Soruları',
        booklet_not_found: 'Kitapçık bulunamadı',
        go_back: 'Geri Dön',
        start_test: 'Teste Başla',
        // Booklet Take
        of: '/',
        answered: 'cevaplanmış',
        your_answer: 'Cevabınız',
        type_your_answer: 'Cevabınızı buraya yazın...',
        previous: 'Önceki',
        next: 'Sonraki',
        submit_booklet: 'Kitapçığı Gönder',
        submitting: 'Gönderiliyor...',
        please_answer_questions: 'Lütfen göndermeden önce en az bir soruyu cevaplayın.',
        confirm_submit_booklet: 'Cevaplarınızı göndermek istediğinizden emin misiniz? Gönderildikten sonra değiştiremezsiniz.',
        cancel_and_go_back: 'İptal Et ve Geri Dön',
        // Booklet Results
        booklet_results: 'Kitapçık Sonuçları',
        test_completed: 'Test Tamamlandı!',
        points: 'puan',
        topic_mastery: 'Konu Hakimiyeti',
        strong: 'Güçlü',
        needs_practice: 'Pratik Gerekli',
        detailed_feedback: 'Detaylı Geri Bildirim',
        model_answer: 'Örnek Cevap',
        back_to_dashboard: 'Ana Sayfaya Dön',
        retake_test: 'Testi Tekrar Al',
        results_not_found: 'Sonuçlar bulunamadı',
      },
      en: {
        dashboard_title: 'BridgePrep',
        dashboard_subtitle: 'BridgePrep students to global and local exams',
        general_mentor: 'General STEM Mentor',
        general_mentor_desc: 'Help with all STEM subjects',
        physics_mentor: 'Physics Mentor',
        physics_mentor_desc: 'Mechanics, forces, energy and more',
        math_mentor: 'Math Mentor',
        math_mentor_desc: 'Calculus, functions, derivatives and integrals',
        chemistry_mentor: 'Chemistry Mentor',
        chemistry_mentor_desc: 'Atoms, molecules, reactions',
        biology_mentor: 'Biology Mentor',
        biology_mentor_desc: 'Cells, genetics, ecology',
        evaluator: 'Response Evaluator',
        evaluator_desc: 'Evaluate your written responses',
        question_generator: 'Question Generator',
        question_generator_desc: 'Generate AP and TYT/AYT questions',
        study_planner: 'Study Planner',
        study_planner_desc: 'Personalized study schedule',
        start_chat: 'Start Chat',
        type_message: 'Type your message...',
        send: 'Send',
        new_chat: 'New Chat',
        back: 'Back',
        discipline: 'Discipline',
        exam_context: 'Exam Context',
        select_discipline: 'Select discipline',
        physics: 'Physics',
        mathematics: 'Mathematics',
        chemistry: 'Chemistry',
        biology: 'Biology',
        evaluate: 'Evaluate',
        student_response: 'Student Response',
        question_context: 'Question Context (Optional)',
        enter_response: 'Enter your response here...',
        enter_context: 'Enter question context here...',
        evaluation_result: 'Evaluation Result',
        generate_questions: 'Generate Questions',
        topic: 'Topic',
        enter_topic: 'Enter topic (e.g., Newton\'s Second Law)',
        difficulty: 'Difficulty',
        easy: 'Easy',
        medium: 'Medium',
        hard: 'Hard',
        number_of_questions: 'Number of Questions',
        format: 'Format',
        generate: 'Generate',
        generated_questions: 'Generated Questions',
        create_plan: 'Create Plan',
        grade_level: 'Grade Level',
        target_exams: 'Target Exams',
        weekly_hours: 'Weekly Hours',
        hours: 'hours',
        weak_topics: 'Weak Topics (Optional)',
        study_plan_result: 'Study Plan',
        loading: 'Loading...',
        error: 'An error occurred',
        // Question Bank
        question_bank: 'Question Bank',
        question_bank_desc: 'Thousands of questions',
        filters: 'Filters',
        all: 'All',
        exam_type: 'Exam Type',
        no_questions_found: 'No questions found',
        question: 'Question',
        options: 'Options',
        correct_answer: 'Correct Answer',
        solution: 'Solution',
        // Teacher Portal
        teacher_portal: 'Teacher Portal',
        teacher_portal_desc: 'Submit questions',
        submit_question: 'Submit Question',
        question_text: 'Question Text',
        write_question: 'Write your question here...',
        submit: 'Submit',
        my_submissions: 'My Submissions',
        no_submissions: 'No submissions yet',
        question_submitted: 'Question submitted successfully!',
        no_access: 'You do not have access to this page.',
        status: 'Status',
        // Booklet Designer
        booklet_designer: 'Booklet Designer',
        booklet_designer_desc: 'Personal booklet',
        create_new_booklet: 'Create New Booklet',
        week_number: 'Week Number',
        focus_subjects: 'Focus Subjects',
        focus_topics: 'Focus Topics (comma separated)',
        my_booklets: 'My Booklets',
        no_booklets: 'No booklets yet',
        week: 'Week',
        questions: 'questions',
        minutes: 'min',
        // Booklet View
        learning_objectives: 'Learning Objectives',
        sections: 'Sections',
        no_questions_in_booklet: 'No questions in this booklet yet',
        make_sure_questions: 'Make sure there are questions in the question bank or create a new booklet',
        reflection_questions: 'Reflection Questions',
        booklet_not_found: 'Booklet not found',
        go_back: 'Go Back',
        start_test: 'Start Test',
        // Booklet Take
        of: 'of',
        answered: 'answered',
        your_answer: 'Your Answer',
        type_your_answer: 'Type your answer here...',
        previous: 'Previous',
        next: 'Next',
        submit_booklet: 'Submit Booklet',
        submitting: 'Submitting...',
        please_answer_questions: 'Please answer at least one question before submitting.',
        confirm_submit_booklet: 'Are you sure you want to submit your answers? You cannot change them after submission.',
        cancel_and_go_back: 'Cancel and Go Back',
        // Booklet Results
        booklet_results: 'Booklet Results',
        test_completed: 'Test Completed!',
        points: 'points',
        topic_mastery: 'Topic Mastery',
        strong: 'Strong',
        needs_practice: 'Needs Practice',
        detailed_feedback: 'Detailed Feedback',
        model_answer: 'Model Answer',
        back_to_dashboard: 'Back to Dashboard',
        retake_test: 'Retake Test',
        results_not_found: 'Results not found',
      }
    };
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};